module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-14.27bb0809.png";